var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('l-slider',{attrs:{"items":_vm.comics},on:{"finish":function () { return _vm.$router.replace('/education2/hub'); }}})}
var staticRenderFns = []

export { render, staticRenderFns }